// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Dashboard React components
import DSBox from "components/DSBox";
import DSTypography from "components/DSTypography";

// Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";

// Dashboard React base styles
import typography from "assets/theme/base/typography";

// Dashboard layout components
import BuildByDevelopers from "layouts/dashboard/components/BuildByDevelopers";
import WorkWithTheRockets from "layouts/dashboard/components/WorkWithTheRockets";
import Projects from "layouts/dashboard/components/Projects";
import OrderOverview from "layouts/dashboard/components/OrderOverview";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import gradientLineChartData from "layouts/dashboard/data/gradientLineChartData";

import Chartfcomp from 'layouts/dashboard/components/Chartfcomp.js';
//import CountriesFilter from 'layouts/dashboard/components/CountriesFilter.js';

function Dashboard() {
  const { size } = typography;
  const { chart, items } = reportsBarChartData;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DSBox py={3}>
        <DSBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "Weekly Sales" }}
                count="$623,000"
                percentage={{ color: "success", text: "+25%" }}
                icon={{ color: "info", component: "paid" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "weekly users" }}
                count="12,800"
                percentage={{ color: "success", text: "+4%" }}
                icon={{ color: "info", component: "public" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "new Users" }}
                count="+2,762"
                percentage={{ color: "error", text: "-2.5%" }}
                icon={{ color: "info", component: "person_add" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "YTD sales" }}
                count="$1,603,430"
                percentage={{ color: "success", text: "+5%" }}
                icon={{
                  color: "info",
                  component: "shopping_cart",
                }}
              />
            </Grid>
          </Grid>
        </DSBox>
        <DSBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={7}>
              <BuildByDevelopers />
            </Grid>
            <Grid item xs={12} lg={5}>
              <WorkWithTheRockets />
            </Grid>
          </Grid>
        </DSBox>
        <DSBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={5}>
              <ReportsBarChart
                title="Tracking Item"
                description={
                  <>
                    (<strong>+15%</strong>) than last quarter
                  </>
                }
                chart={chart}
                items={items}
              />
            </Grid>
            <Grid item xs={12} lg={7}>
            <VerticalBarChart
                title="Trend Overview"
                description={
                  <DSBox display="flex" alignItems="center">
                    <DSBox fontSize={size.lg} color="success" mb={0.3} mr={0.5} lineHeight={0}>
                      <Icon className="font-bold">arrow_upward</Icon>
                    </DSBox>
                    <DSTypography variant="button" textColor="text" fontWeight="medium">
                      14% more{" "}
                      <DSTypography variant="button" textColor="text" fontWeight="regular">
                        in 2023
                      </DSTypography>
                    </DSTypography>
                  </DSBox>
                }
                height="20.25rem"
                chart={gradientLineChartData}
              />
            </Grid>
          </Grid>
        </DSBox>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={8}>
            <Projects />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <OrderOverview />
          </Grid>
        </Grid>
        <Grid item xs={12} lg={7}>
            </Grid>
            <DSBox mb={3}>
          <Grid container spacing={3}>
          
            <Grid item xs={8} lg={8}>
            <>        
            <Chartfcomp />
            </>
            </Grid>            
          </Grid>
        </DSBox>
      </DSBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
